import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { FormGroup, FormControl, Validators } from '@angular/forms'

@Component({
    selector: 'app-update-profile',
    templateUrl: './update-profile.component.html',
    styleUrls: ['./update-profile.component.css'],
    standalone: false
})
export class UpdateProfileComponent implements OnInit {
  userDetails;
  role: string;

  customerForm = new FormGroup({
    userName: new FormControl({value: '', disabled: true}),
    fullName: new FormControl(''),
    companyName: new FormControl(''),
    country: new FormControl(''),
    mailingAddress: new FormControl(''),
    contactNumber: new FormControl(''),
    email: new FormControl({value: '', disabled: true}),
    pContactNumber: new FormControl(''),
    pEmail: new FormControl({value: '', disabled: false}),
    licenseCode: new FormControl({value: '', disabled: true}),
    gstNumber: new FormControl({value: '', disabled: true}),
    PAN: new FormControl({value: '', disabled: true}),
    currency: new FormControl({value: '', disabled: true}),
    bankName: new FormControl({value: '', disabled: true}),
    bankAccountNumber: new FormControl({value: '', disabled: true}),
    IFSC: new FormControl({value: '', disabled: true}),
    SWIFT: new FormControl({value: '', disabled: true}),
    domainName: new FormControl(''),
  });

  moderatorForm = new FormGroup({
    userName: new FormControl({value: '', disabled: true}),
    fullName: new FormControl(''),
    domainName: new FormControl(''),
    contactNumber: new FormControl(''),
    email: new FormControl({value: '', disabled: true}),
  });

  techExpertForm = new FormGroup({
    userName: new FormControl({value: '', disabled: true}),
    fullName: new FormControl(''),
    domainName: new FormControl(''),
    contactNumber: new FormControl(''),
    email: new FormControl({value: '', disabled: true}),
    PAN: new FormControl(''),
    bankName: new FormControl(''),
    bankAccountNumber: new FormControl(''),
    IFSC: new FormControl(''),
  });

  constructor(private loginService: LoginService ,private router : Router) {}

  ngOnInit() {
    this.loginService.getUserProfile().subscribe(
      res => {
        this.userDetails = res['user'];
        console.log(this.userDetails)
        this.role = this.userDetails.role;
        ////console.log('got logged in user', this.userDetails, this.role);
        switch(this.role){
          case 'CUSTOMER':
           //console.log(this.userDetails)
            this.customerForm.get('userName').setValue(this.userDetails.userName)
            this.customerForm.get('fullName').setValue(this.userDetails.fullName)
            this.customerForm.get('companyName').setValue(this.userDetails.companyName)
            this.customerForm.get('country').setValue(this.userDetails.country)
            this.customerForm.get('mailingAddress').setValue(this.userDetails.mailingAddress)
            this.customerForm.get('contactNumber').setValue(this.userDetails.contactNumber)
            this.customerForm.get('email').setValue(this.userDetails.email)
            this.customerForm.get('pContactNumber').setValue(this.userDetails.pContactNumber)
            this.customerForm.get('pEmail').setValue(this.userDetails.pEmail)
            this.customerForm.get('licenseCode').setValue(this.userDetails.licenseCode)
            this.customerForm.get('gstNumber').setValue(this.userDetails.gstNumber)
            this.customerForm.get('PAN').setValue(this.userDetails.PAN)
            this.customerForm.get('currency').setValue(this.userDetails.currency)
            this.customerForm.get('bankName').setValue(this.userDetails.bankName)
            this.customerForm.get('bankAccountNumber').setValue(this.userDetails.bankAccountNumber)
            this.customerForm.get('IFSC').setValue(this.userDetails.IFSC)
            this.customerForm.get('SWIFT').setValue(this.userDetails.SWIFT)
            this.customerForm.get('domainName').setValue(this.userDetails.domainName)
            break;

          case 'MODERATOR':
            this.moderatorForm.get('userName').setValue(this.userDetails.userName)
            this.moderatorForm.get('fullName').setValue(this.userDetails.fullName)
            this.moderatorForm.get('domainName').setValue(this.userDetails.domainName)
            this.moderatorForm.get('contactNumber').setValue(this.userDetails.contactNumber)
            this.moderatorForm.get('email').setValue(this.userDetails.email)
            break;

          case 'TECHEXPERT':
            this.techExpertForm.get('userName').setValue(this.userDetails.userName)
            this.techExpertForm.get('fullName').setValue(this.userDetails.fullName)
            this.techExpertForm.get('domainName').setValue(this.userDetails.domainName)
            this.techExpertForm.get('contactNumber').setValue(this.userDetails.contactNumber)
            this.techExpertForm.get('email').setValue(this.userDetails.email)
            this.techExpertForm.get('PAN').setValue(this.userDetails.PAN)
            this.techExpertForm.get('bankName').setValue(this.userDetails.bankName)
            this.techExpertForm.get('bankAccountNumber').setValue(this.userDetails.bankAccountNumber)
            this.techExpertForm.get('IFSC').setValue(this.userDetails.IFSC)
            break;
        }
      },
      err => {
       //console.log('Did not get user', err);
        this.router.navigateByUrl('/signin');
      }
    )


  }

  onSubmit(){
    switch(this.role){
      case 'CUSTOMER':
       //console.log('customer form', this.customerForm.getRawValue())
        this.loginService.updateUser(this.customerForm.getRawValue()).subscribe(
          res=>{
           //console.log('Successfully updates', res)
            alert('Details Successfully Updated');
            this.router.navigateByUrl('userprofile');
          },
          err => {
           //console.log('error updating', err)
          }
        )
        break;
      case 'MODERATOR':
       //console.log('moderator form', this.moderatorForm.getRawValue())
        this.loginService.updateUser(this.moderatorForm.getRawValue()).subscribe(
          res=>{
           //console.log('Successfully updates', res)
            alert('Details Successfully Updated');
            this.router.navigateByUrl('userprofile');
          },
          err => {
           //console.log('error updating', err)
          }
        )
        break;
      case 'TECHEXPERT':
       //console.log('tech form', this.techExpertForm.getRawValue())
        this.loginService.updateUser(this.techExpertForm.getRawValue()).subscribe(
          res=>{
           //console.log('Successfully updates', res)
            alert('Details Successfully Updated');
            this.router.navigateByUrl('userprofile');
          },
          err => {
           //console.log('error updating', err)
          }
        )
        break;
    }
  }
}
